import { CHAT_UNAVAILABLE } from './chatUserError';

/** Which runtime answers a homepage chat. Mirrored in electron agentEngine. */
export type ChatEngine = 'cursor' | 'direct';

/** Cursor is hidden in the UI; homepage chat is Ask Crate Hackers. */
export const DEFAULT_CHAT_ENGINE: ChatEngine = 'direct';

export const CHAT_ENGINES: Array<{
  id: ChatEngine;
  label: string;
  hint: string;
}> = [
  {
    id: 'direct',
    label: 'Ask Crate Hackers',
    hint: 'Same DJ tools, no coding agent',
  },
  {
    id: 'cursor',
    label: 'Cursor',
    hint: 'Coding agent with DJ tools',
  },
];

export const isChatEngine = (value: unknown): value is ChatEngine =>
  value === 'cursor' || value === 'direct';

const STORAGE_KEY = 'cratehackers.agentChat.engine';

export const readAgentChatEngine = (): ChatEngine => {
  try {
    if (localStorage.getItem(STORAGE_KEY) === 'cursor') {
      localStorage.setItem(STORAGE_KEY, DEFAULT_CHAT_ENGINE);
    }
  } catch {
    // Private mode can throw; new chats still use the homepage engine.
  }
  return DEFAULT_CHAT_ENGINE;
};

export const writeAgentChatEngine = (engine: ChatEngine): void => {
  try {
    localStorage.setItem(STORAGE_KEY, engine);
  } catch {
    // Private mode can throw; the session still holds the choice.
  }
};

export const chatEngineLabel = (engine?: ChatEngine | null): string =>
  engine === 'cursor' ? 'Cursor' : 'Ask Crate Hackers';

export const missingChatKeyHint = (_engine?: ChatEngine | null): string =>
  CHAT_UNAVAILABLE;
